
/* eslint-disable @typescript-eslint/camelcase */
import { Options, Vue } from "vue-class-component";
import Title from "@/app/ui/components/data-wrapper/title.vue";
import debounce from "lodash/debounce";
import {
  dateToDateString,
  dateToTime,
  formattedNPWP
} from "@/app/infrastructures/misc/Utils";
import { getPhoneDisplayCode } from "@/app/infrastructures/misc/common-library/v2/FormatPhoneNumber";
import { codePhoneCountry } from "@/app/ui/views/shipment/booking/booking-utils";
import SelectPhoneCountry from "../../shipment/booking/component/select-phone-country.vue";
import { AccountController } from "@/app/ui/controllers/AccountController";
import {
  DistrictFieldRules,
  getFieldRulesForDistrict,
  formatTaxIdInput,
  validateTaxIdValue,
  resolveDistrictFieldRules
} from "@/app/infrastructures/misc/common-library/MalaysiaDistrictFieldRules";
import Tooltip from "@/app/ui/components/tooltip/index.vue";
import DetailLayout from "@/app/ui/layout/detail-layout.vue";
import { PartnerController } from "@/app/ui/controllers/PartnerController";
import { LocationController } from "@/app/ui/controllers/LocationController";
import { BeneficiaryAccountController } from "@/app/ui/controllers/BeneficiaryAccountController";
import ModalAddBank from "./modal-add-bank.vue";
import { PosController } from "@/app/ui/controllers/PosController";
import { RequestListPartner } from "@/data/payload/api/PartnerApiRequest";
import { PosData } from "@/domain/entities/Pos";
import formatInputFloat from "@/app/infrastructures/misc/common-library/FormatInputFloat";
import FileAttachment from "./file-attachment.vue";
import formatInputMoney from "@/app/infrastructures/misc/common-library/FormatInputMoney";
import { FlagsPermissionPartnerManagement } from "@/feature-flags/flags-permission-partner-management";
import {
  UpdatePartnerApiRequest
} from "@/data/payload/api/PartnerApiRequest";
import SectionAreaDelivery from "./section-area-delivery.vue";

@Options({
  components: {
    Title,
    Tooltip,
    DetailLayout,
    ModalAddBank,
    FileAttachment,
    SectionAreaDelivery,
    SelectPhoneCountry
  },
  beforeRouteLeave(to: any, from: any, next: any) {
    if (to.name === "login") {
      next();
    }
    if (!this.openSuccess) {
      this.onOpenClosePage(to);
      if (this.answer) {
        this.answer = false;
        next();
      } else {
        next(false);
      }
    } else {
      this.setModalSuccess(false);
      next();
    }
  }
})
export default class Update extends Vue {
  props: any = this.$props;
  dataPartnerArea = {partnerAreaDelivery:[{cityCode: "", district: []}]}
  selectedDistrictCountryCode = "ID";
  private _districtSeq = 0;

  get districtFieldRules(): DistrictFieldRules {
    return getFieldRulesForDistrict(this.selectedDistrictCountryCode, "partner");
  }

  get taxMaxLength(): string {
    return this.districtFieldRules.applyNpwpMask
      ? "20"
      : String(this.districtFieldRules.taxIdMaxLength);
  }

  get taxPlaceholder(): string {
    return this.districtFieldRules.applyNpwpMask
      ? "00.000.000.0-000.000"
      : "Masukan Nomor Pajak";
  }

  get districtCurrencyPrefix(): string {
    return this.districtFieldRules.currencyLabel;
  }

  get getTitle() {
    const name = this.$route.meta?.name;
    const key = name != null ? String(name) : "";
    return key && key.includes(".") ? this.$t(key) : key;
  }

  consolePhoneCode = "";

  get errorPhoneConsole() {
    return {
      error: this.error.phone,
      errorPhone: false,
      errorMandatory: false,
      errorPhoneCode: false,
      phoneCharMinimal: false,
      message: ""
    };
  }

  // add bank midtrans enhancement
  get showAddBank() {
    return PartnerController.showAddBank;
  }
  onShowAddBank(val: boolean) {
    PartnerController.setShowAddBank(val);
  }

  onDeleteBank() {
    this.beneficiaryDetail.bankAccountLogo = "";
    this.beneficiaryDetail.bankAccountName = "";
    this.beneficiaryDetail.bankAccountLabel = "";
    this.beneficiaryDetail.bankName = "";
    this.beneficiaryDetail.bankAccountNumber = "";
    this.beneficiaryDetail.bankAccountEmail = "";
  }

  assignDataPartnerAreaFormDetail(data: any) {
    if (this.detailData.partnerType !== "console") {
      return this.dataPartnerArea.partnerAreaDelivery = [];
    }
    return this.dataPartnerArea.partnerAreaDelivery = data.partnerAreaDeliveries.map((item: any) => ({
      cityCode: {code:item.cityCode, name: `${item.cityCode} - ${item.cityName}`},
      district: item.districts.map((district: any) => ({
        code: district.code,
        name: district.name
      }))
    }));
  }

  // Get Data
  async mounted() {
    await this.getDetail();
    await this.resolveInitialDistrictRules();
    this.filterConsolidators("");
    this.filterSubconsolidators("");
    this.fetchDistricts("");
    await this.fecthCityListData();
    this.getBeneficiaryAccount();
    if (this.detailData.partnerPosType === 'branch' ||this.detailData.partnerPosType === 'pickup'){
      this.filterParentPos(this.detailData.partnerPosParentName);
    }
    if (this.$route.meta.form !== "pos") {
      this.filterPartnerPosReverseJourney(
        this.detailData.partnerPosReverseJourneyName
      );
    }
    this.assignDataPartnerAreaFormDetail(this.detailData);
  }

  async resolveInitialDistrictRules(): Promise<void> {
    const countryCode = this.detailData?.partnerLocation?.country?.code
    this.selectedDistrictCountryCode = countryCode;
  }

  async onDistrictSelected(obj: any): Promise<void> {
    const seq = ++this._districtSeq;
    if (!obj || obj === "") {
      this.selectedDistrictCountryCode = "ID";
      return;
    }
    const prevCountryCode = this.selectedDistrictCountryCode;
    const rules = await resolveDistrictFieldRules(obj, "partner");
    if (seq !== this._districtSeq) return;
    this.selectedDistrictCountryCode = rules.countryCode;
    if (prevCountryCode !== rules.countryCode) {
      this.applyDistrictSwitchSideEffects();
    }
  }

  applyDistrictSwitchSideEffects(): void {
    this.detailData.partnerPhoneNumber = "";
    this.detailData.partnerTaxNumber = "";
    this.detailData.partnerContactPhoneNumber = [{ no: "", error: false }];
    this.detailData.partnerPosSaldoDepositFormated = "";
    this.error.phone = false;
    this.error.taxNumber = false;
    this.errorContactPhone = false;
  }

  async getDetail() {
    await PartnerController.getPartnerDetail({
      id: Number(this.$route.params.id),
      tieringLevel: this.$route.name === "edit-partner-pos"
    });
  }

  // phone
  formatNumber(value: string) {
    return value.replace(/[\D]+/g, "");
  }

  validatePhone(value: string) {
    this.error.phone = !/^\d+$/.test(value);
  }

  errorMinimalPhone() {
    this.error.phone = this.detailData.partnerPhoneNumber.length < 4;
  }

  errorContactPhone = false;
  validateContactPhone(index: number) {
    this.detailData.partnerContactPhoneNumber[index].error =
      this.detailData.partnerContactPhoneNumber[index].no.length !== 0 &&
      this.detailData.partnerContactPhoneNumber[index].no === false;
    this.errorContactPhone = this.detailData.partnerContactPhoneNumber[
      index
    ].error;
  }

  get partnerTypeForm() {
    const type = this.$route.meta.form as string;
    const accountType: any = {
      "consolidator": "console",
      "sub-consolidator": "sub-console"
    }

    return accountType[type] ?? "pos";
  }

  getBeneficiaryAccount() {
    BeneficiaryAccountController.getBeneficiaryAccList({
      page: 1,
      limit: 1,
      bankAccType: "beneficiary",
      actortype: this.partnerTypeForm,
      actorId: Number(this.$route.params.id)
    });
  }

  get beneficiaryDetail() {
    return BeneficiaryAccountController.beneficiaryDetail;
  }

  get styleStatus() {
    switch (this.detailData.partnerContractStatus.toLowerCase()) {
      case "expired":
        return "bg-red-lp-600 text-red-lp-500 font-medium px-5";
      case "nearly-expired":
        return "font-medium bg-yellow-lp-100 text-yellow-lp-200 font-medium px-5";
      case "waiting":
        return "text-yellow-lp-100 font-medium bg-yellow-lp-200 font-medium px-5";
      default: {
        return "font-medium bg-green-lp-300 text-green-lp-200 font-medium px-5";
      }
    }
  }

  // back
  get partnerTypeUser() {
    if (this.detailData.partnerType === "console") {
      return "consolidator";
    } else if (this.detailData.partnerType === "sub-console") {
      return "sub-consolidator";
    } else {
      return "pos";
    }
  }

  get partnerNameParams() {
    return this.detailData.partnerName;
  }

  goBack() {
    this.$router.push(
      `/partner/${this.partnerTypeUser}/detail/${this.detailData.partnerId}?params=${this.partnerNameParams}`
    );
  }

  get errorCause() {
    return PartnerController.errorCause;
  }

  get detailData(): any {
    return PartnerController.partnerDetail;
  }

  get isLoading() {
    return PartnerController.isLoading;
  }

  // Format Date
  formatDate(date: string) {
    return `${dateToDateString(date)}, ${dateToTime(date)} WIB`;
  }

  isEditTerminated = false;
  newPath = "";
  answer = false;

  onOpenClosePage(to: any) {
    this.isEditTerminated = true;
    this.newPath = to.path;
  }

  removePhoneNumber(index: number) {
    this.tempIndexToRemove = index;
    if (this.tempIndexToRemove > -1) {
      this.detailData.partnerContactPhoneNumber.splice(
        this.tempIndexToRemove,
        1
      );
      this.tempIndexToRemove = -1;
    }
  }

  handlerClose() {
    this.isEditTerminated = false;
    this.answer = true;
    this.$router.push(this.newPath);
  }

  handlerCancelClose() {
    this.answer = false;
    this.isEditTerminated = false;
  }

  // saving
  openConfirmation = false;
  updateConfirmation() {
    this.openConfirmation = true;
  }

  transformPartnerAreaDeliveries(partnerAreaDeliveries: any) {
    if (!Array.isArray(partnerAreaDeliveries)) {
      return [];
    }

    return partnerAreaDeliveries.map(item => {
      try {
        const cityCode = item?.cityCode?.code || '';

        const districtCodes = (item.district || []).map((district: any) => {
          return district?.value || district?.code;
        }).filter((code: any) => code && code !== '');

        if (districtCodes.includes("ALL")) {
          return {
            city_code: cityCode,
            district_codes: ["ALL"]
          };
        }

        return {
          city_code: cityCode,
          district_codes: districtCodes
        };
      } catch (error) {
        console.error('Error transforming item:', error, item);
        return {
          city_code: '',
          district_codes: []
        };
      }
    });
  }

  get updatePartnerRequest() {
    const detail = this.detailData;
    const beneficiary = this.beneficiaryDetail;
  
    return new UpdatePartnerApiRequest(
      detail.partnerId,
      detail.partnerName,
      detail.partnerAddress,
      new Date(detail.partnerEndContract.setUTCHours(24))
        .toISOString()
        .substr(0, 10),
      detail.partnerContactName,
      detail.partnerContactJobTitle,
      detail.partnerContactEmail,
      Array.isArray(detail.partnerContactPhoneNumber)
        ? detail.partnerContactPhoneNumber
            .map((e: any) => {
              const cc = String(e.code || "+62").replace("+", "");
              return `${cc}${e.no || ""}`;
            })
            .join(", ")
        : "",
      beneficiary.bankName,
      beneficiary.bankAccountNumber,
      beneficiary.bankAccountName,
      beneficiary.bankAccountEmail,
      beneficiary.bankAccountLabel,
      typeof detail.partnerDistrict === "object"
        ? (detail.partnerDistrict as any).code
        : detail.partnerDistrictCode,
      detail.partnerLatitude,
      detail.partnerLongitude,
      typeof detail.partnerPosReverseJourney === "object"
        ? (detail.partnerPosReverseJourney as any).id
        : 0,
      detail.partnerPosType,
      detail.partnerPosParentId,
      // `${this.consolePhoneCode.replace("+", "")}${detail.partnerPhoneNumber}`,
      this.formatConsolidatorPhoneForPayload(detail.partnerPhoneNumber),
      detail.partnerTaxNumber,
      detail.partnerParentId,
      detail.partnerParentType,
      detail.partnerCity.map((e: any) => {
        return e.code;
      }),
      detail.partnerIsCodDelivery,
      Number(
        detail.partnerPosBranchCommission
          ? detail.partnerPosBranchCommission.toString().replace(",", ".")
          : detail.partnerPosBranchCommission
      ),
      detail.partnerIsCodBooking,
      detail.partnerIsPcu,
      detail.partnerIsAllowBookVippack,
      detail.partnerPosAttachFiles.filter((item: string) => item),
      Number(detail.partnerPosSaldoDepositFormated.replaceAll(".", "")),
      Number(detail.partnerOwnershipId ? detail.partnerOwnershipId : 0),
      this.transformPartnerAreaDeliveries(this.dataPartnerArea.partnerAreaDelivery),
      detail.partnerIsPosOwnSales,
    );
  }

  openSuccess = false;
  async onCreate() {
    this.openConfirmation = false;
    const resp = await PartnerController.updatePartner(this.updatePartnerRequest);
    this.openSuccess = resp;
  }

  onCloseConfirmation() {
    this.openConfirmation = false;
  }

  onCloseSuccess() {
    this.goBack();
  }

  setModalSuccess(value: boolean) {
    this.openSuccess = value;
  }

  //partner name
  get partnerName() {
    if (this.detailData.partnerType === "console") {
      return "Consolidator";
    } else if (this.detailData.partnerType === "sub-console") {
      return "Sub Consolidator";
    } else {
      return "POS";
    }
  }

  // tooltip
  isOpenTooltipAddCity = false;

  // error
  error = {
    phone: false,
    taxNumber: false,
    contactPhone: false,
    contactEmail: false,
    bankEmail: false,
    accountBankNo: false,
    commision: false
  };
  // form
  form = {
    consolidators: "",
    cityExclude: [],
    phone: "",
    taxNumber: "",
    contactPhones: [
      {
        no: "",
        error: false
      }
    ]
  };
  tempIndexToRemove = 0;

  // districts
  fetchDistricts = debounce((search: string) => {
    LocationController.getDistrictList({
      search: search,
      status: "active",
      page: 1,
      limit: 10,
      cache: true
    });
  }, 250);

  get districts() {
    return LocationController.districtData.districtData.map(e => ({
      id: e.id,
      name: `${e.name}, ${e.cityName}`,
      code: `${e.code}`,
      cityCode: `${e.cityCode}`
    }));
  }

  get isLoadingDistricts() {
    return LocationController.isLoadingDistrict;
  }

  // districts toppings
  get cityOver() {
    if (this.form.cityExclude.length > 5) {
      this.form.cityExclude.pop();
      return true;
    }

    return false;
  }

  get isLoadingCity() {
    return LocationController.isLoading;
  }

  async fecthCityListData() {
    LocationController.getCityList({
      search: "",
      status: "",
      page: 1,
      limit: 10
    });
  }

  get cityListData() {
    return LocationController.cityData.cityData.map(e => {
      return {
        code: e.code,
        name: e.name
      };
    });
  }

  filterCityList = debounce((search: string) => {
    if (search.length > 2 || !search) {
      LocationController.getCityList({
        search: search,
        status: "",
        page: 1,
        limit: 10
      });
    }
  }, 250);

  // subconsolidators
  filterSubconsolidators = debounce((search: string) => {
    if (this.detailData.partnerParentType !== undefined) {
      PartnerController.getConsolidatorsByCity({
        search: search,
        page: 1,
        limit: 10,
        cityCode: "",
        type: "console",
        status: this.partnerStatus
      });
    }
  }, 250);
  
  // consolidators
  filterConsolidators = debounce((search: string) => {
    if (this.detailData.partnerParentType !== undefined) {
      PartnerController.getConsolidatorsByCity({
        search: search,
        page: 1,
        limit: 10,
        cityCode: this.detailData.partnerLocationCityCode,
        type: this.detailData.partnerParentType,
        status: this.partnerStatus
      });
    }
  }, 250);

  get consolidators() {
    if (
      this.$route.meta.form === "sub-consolidator" ||
      this.$route.meta.form === "pos"
    ) {
      return PartnerController.consolidatorsByCity.consolidatorByCityData.map(
        e => ({
          id: e.id,
          name: `${e.name}`
        })
      );
    }
    return null;
  }
  
  get subconsolidators() {
      return PartnerController.consolidatorsActiveByCity.consolidatorByCityData.map(
        e => ({
          id: e.id,
          name: `${e.name}`
        })
      );
    }

  get modelSubconsolidator() {
    if (this.detailData.partnerOwnershipId) {
      return {
        id: this.detailData.partnerOwnershipId,
        name: this.detailData.partnerOwnershipName
      };
    }
    return "";
  }

  get modelPartnerParent() {
    if (this.detailData.partnerParentId) {
      return {
        id: this.detailData.partnerParentId,
        name: this.detailData.partnerParentName
      };
    }
    return "";
  }

  onChangePartnerParent(item: any) {
    PartnerController.setPartnerParent(item);
  }

  onChangePartnerOwnership(item: any) {
    PartnerController.setPartnerOwnership(item);
  }

  get isLoadingConsolidators() {
    return PartnerController.loadingConsolidatorsByCity;
  }

  isShowAreaDeliverySection = true;
  citiesList: any[] = [];
  loadingGetCityList = false;

  async fetchCityList(search: string) {
    try {
      this.loadingGetCityList = true;
      const res = await LocationController.getDestinationCities({
        search: search,
        status: "",
        page: 1,
        limit: 10
      });
      this.citiesList = res.data.map((e: any) => ({
        ...e,
        name: `${e.code} - ${e.name}`
      }));
      this.loadingGetCityList = false;
    } catch (error) {
      this.loadingGetCityList = false;
    }
  }

  async showPartnerAreaSection(val: string) {
    const flagValue = FlagsPermissionPartnerManagement.permission_area_delivery_by_3lc_enable.getValue();

    const shouldShow = Array.isArray(flagValue) && flagValue.includes(val);
    if (shouldShow) {
      await this.fetchCityList(val)
      this.dataPartnerArea.partnerAreaDelivery = [{
        cityCode: this.citiesList[0],
        district: [{ name: "Semua", code: "ALL" }] as any
      }];
    }
    this.isShowAreaDeliverySection = shouldShow;
    return this.isShowAreaDeliverySection;
  }

  cityCode = "";
  partnerStatus = "";
  async getConsolidatorsByCity(obj: any) {
    await this.onDistrictSelected(obj);
    this.onChangePartnerParent("");
    this.onChangePartnerOwnership("");
    this.form.consolidators = "";
    this.detailData.partnerLocationCityCode =
      typeof obj === "object"
        ? obj.cityCode
        : this.detailData.partnerLocationCityCode;
    if (typeof obj === "object") {
      this.dataPartnerArea = {partnerAreaDelivery:[]}
      this.showPartnerAreaSection(obj.cityCode);
    }
    this.filterConsolidators("");
    this.filterSubconsolidators("");
    PosController.setDefaultPosList();
    this.detailData.partnerPosParentId = undefined as number | undefined;
    this.detailData.partnerPosParentName = "";
    this.detailData.partnerPosReverseJourney = "";
    if (this.$route.meta.form !== "pos") {
      this.filterPartnerPosReverseJourney("");
    }
  }

  // partners area
  partnerAreaTypeList = [
    {
      name: "Pilih partner area",
      value: ""
    },
    {
      name: "Consolidator",
      value: "console"
    },
    {
      name: "Sub Consolidator",
      value: "sub-console"
    }
  ];

  isOpenPartnerType = false;
  onOpenSelectPartnerType() {
    this.isOpenPartnerType = true;
  }

  onCloseSelectPartnerType() {
    this.isOpenPartnerType = false;
  }

  onSelectPartnerType(key: string, value: string) {
    this.onCloseSelectPartnerType();
    PartnerController.setPartnerParentType(value);
    this.onChangePartnerParent("");
    this.onChangePartnerOwnership("");
    PartnerController.getConsolidatorsByCity({
      search: "",
      page: 1,
      limit: 10,
      cityCode: this.detailData.partnerLocationCityCode,
      type: this.detailData.partnerParentType,
      status: this.partnerStatus
    });
  }

  normalizeConsolePhoneFromDetail() {
    if (this.detailData.partnerType !== "console") {
      return;
    }
    const raw = String(this.detailData.partnerPhoneNumber || "")
      .replace(/^\+/, "")
      .replace(/\s/g, "");
    if (!raw) {
      this.consolePhoneCode = getPhoneDisplayCode(
        AccountController.accountData?.countryCode
      );
      return;
    }
    const p = codePhoneCountry(raw);
    this.consolePhoneCode = p.code;
    this.detailData.partnerPhoneNumber = p.number;
  }

  setConsolePhoneNumber(val: string) {
    this.detailData.partnerPhoneNumber = val;
    this.error.phone = !/^\d+$/.test(val) || val.length < 4;
  }

  setConsolePhoneCode(val: string) {
    this.consolePhoneCode = val;
  }

  setContactPhoneNumber(val: string, index: number) {
    this.detailData.partnerContactPhoneNumber[index].no = val;
    this.detailData.partnerContactPhoneNumber[index].error =
      val.length > 0 && (!/^\d+$/.test(val) || val.length < 4);
    this.errorContactPhone = this.detailData.partnerContactPhoneNumber[
      index
    ].error;
  }

  setContactPhoneCodeNumber(val: string, index: number) {
    this.detailData.partnerContactPhoneNumber[index].code = val;
  }

  emptyContactPhone(idx: number) {
    let result = false;
    const check = this.detailData.partnerContactPhoneNumber
      ? this.detailData.partnerContactPhoneNumber
      : [];
    if (check.length !== 0) {
      this.detailData.partnerContactPhoneNumber.map(
        (key: any, index: number) => {
          if (idx === index) {
            if (key.no === "" || key.no.length < 4) {
              result = true;
              this.errorContactPhone = true;
            }
          }
        }
      );
    }
    return result;
  }

  addPhone() {
    if (this.detailData.partnerContactPhoneNumber.length > 2) {
      return;
    }

    this.detailData.partnerContactPhoneNumber.push({
      no: "",
      code: getPhoneDisplayCode(AccountController.accountData?.countryCode),
      error: false,
      message: "partnerManagement.error.phoneInvalid"
    });
  }

  get isMaxContactPhone() {
    return this.detailData.partnerContactPhoneNumber?.length < 3;
  }

  // npwp
  formatTax(value: string) {
    if (this.districtFieldRules.applyNpwpMask) {
      return formattedNPWP(value.replace(/[\D]+/g, ""));
    }
    return formatTaxIdInput(value, this.districtFieldRules);
  }

  validateTaxNumber(value: string) {
    if (this.districtFieldRules.applyNpwpMask) {
      this.error.taxNumber = !/[0-9-.]+/.test(value);
      if (value.length < 20) {
        this.error.taxNumber = true;
      }
      return;
    }
    this.error.taxNumber = !validateTaxIdValue(value, this.districtFieldRules);
  }

  private formatConsolidatorPhoneForPayload(phone: string): string {
    const rules = this.districtFieldRules;
    const dialDigits = rules.phoneDialCode.replace(/\D/g, "");
    const raw = (phone || "").replace(/^\+/, "").replace(/^0+/, "");
    if (raw.startsWith(dialDigits)) {
      return rules.countryCode === "MY" ? raw : `+${raw}`;
    }
    return rules.countryCode === "MY" ? `${dialDigits}${raw}` : `+${dialDigits}${raw}`;
  }

  formatLatLong(val: string) {
    return val.replace(/[^0-9+-.]+/g, "").replace(",", "");
  }

  // bank
  get bankModelValue() {
    if (this.beneficiaryDetail.bankName) {
      return {
        name: this.beneficiaryDetail.bankAccountLabel,
        value: this.beneficiaryDetail.bankName
      };
    }
    return "";
  }
  fetchListBank() {
    PartnerController.getListPartnerBank();
  }
  get bankList() {
    return PartnerController.partnerBank.map(bank => {
      return { name: bank.bankName, value: bank.bankCode };
    });
  }
  get loadingBank() {
    return PartnerController.isLoadingBank;
  }
  onSelectBank(model: any) {
    this.beneficiaryDetail.bankName = model.value;
    this.beneficiaryDetail.bankAccountLabel = model.name;
  }

  // email
  validateEmail(value: string) {
    this.error.contactEmail = !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  validateEmailBank(value: string) {
    this.error.bankEmail =
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) && value.length !== 0;
  }

  // account bank no
  validateAccountNo(value: string) {
    this.error.accountBankNo = !/^\d+$/.test(value) && value.length !== 0;
  }

  isPartnerAreaDeliveryValid(partnerAreaDelivery: any) {
    if (this.detailData.partnerType !== "console" || !this.isShowAreaDeliverySection) {
      return true;
    }
    if (!partnerAreaDelivery || !Array.isArray(partnerAreaDelivery) || partnerAreaDelivery.length === 0) {
      return false;
    }
    
    return partnerAreaDelivery.every((item: any) => 
      item?.cityCode && 
      item?.cityCode !== '' && 
      item?.district && 
      Array.isArray(item.district) && 
      item.district.length > 0 &&
      item.district.every((district: any) => district?.value || district?.code)
    );
  };

  get validateForm() {
    const validateRequired = !(
      this.detailData.partnerName &&
      this.detailData.partnerAddress &&
      this.detailData.partnerContactPhoneNumber &&
      this.detailData.partnerContactName &&
      this.detailData.partnerContactJobTitle &&
      this.detailData.partnerContactEmail &&
      this.detailData.partnerLongitude &&
      this.detailData.partnerLatitude &&
      !this.isParentPos &&
      !this.isParentPosDipickup &&
      this.validateFormUploadForPos &&
      this.isPartnerAreaDeliveryValid(this.dataPartnerArea.partnerAreaDelivery)
    );
    const validateError =
      this.error.accountBankNo ||
      this.error.bankEmail ||
      this.error.contactEmail ||
      this.error.phone ||
      this.error.taxNumber ||
      this.error.contactPhone ||
      this.errorContactPhone;
    return validateRequired || validateError;
  }

  get validateFormUploadForPos() {
    if (this.detailData.partnerType === "pos") {
      return !this.validateFiles && !this.isLoadingUpload;
    }

    return true;
  }

  get validateParent() {
    if (this.detailData.partnerType === "console") {
      return false;
    }
    return !(
      this.detailData.partnerParentId && this.detailData.partnerParentName
    );
  }

  // kecamatan kota
  errorCaptionKecamatanKota = "";
  errorKecamatanKota = false;

  onCheckedCODDeliveryPartner(value: any) {
    this.detailData.partnerIsCodDelivery = value;
  }

  onCheckedPartnerIsPCU(value: any) {
    this.detailData.partnerIsPcu = value;
  }

  onCheckedCODBookingPartner(value: any) {
    this.detailData.partnerIsCodBooking = value;
  }

  onCheckedPartnerIsAllowBookVippack(value: any) {
    this.detailData.partnerIsAllowBookVippack = value;
  }

  onCheckedPartnerIsPosOwnSales(value: any) {
    this.detailData.partnerIsPosOwnSales = value;
  }

  // tipe pos
  openTypePos = false;
  typePos = [
    { name: "Pilih tipe", value: "" },
    { name: "POS Parent", value: "parent" },
    { name: "POS Child", value: "branch" },
    { name: "POS Dipickup", value: "pickup" }
  ];

  onChangeTypePos(name: string, val: string) {
    const partnerPos: any = {
      "": {
        id: undefined as number | undefined,
        name: ""
      },
      parent: {
        id: undefined as number | undefined,
        name: ""
      },
      branch: {
        id: this.detailData.partnerPosParentIdDefault,
        name: this.detailData.partnerPosParentNameDefault
      },
      pickup: {
        id: this.detailData.partnerPosParentIdDefault,
        name: this.detailData.partnerPosParentNameDefault
      }
    };

    this.detailData.partnerPosParentId = partnerPos[val].id;
    this.detailData.partnerPosParentName = partnerPos[val].name;
    this.detailData.partnerPosType = val;
    this.openTypePos = false;
  }

  // parent pos
  get isParentPos() {
    if (this.detailData.partnerType === "pos") {
      if (this.detailData.partnerPosType) {
        return (
          this.detailData.partnerPosType === "branch" &&
          !this.detailData.partnerPosParentId
        );
      } else {
        return true;
      }
    }

    return false;
  }

  get isParentPosDipickup() {
    if (this.detailData.partnerType === "pos") {
      if (this.detailData.partnerPosType) {
        return (
          this.detailData.partnerPosType === "pickup" &&
          !this.detailData.partnerPosParentId
        );
      } else {
        return true;
      }
    }

    return false;
  }

  filterParentPos = debounce((search: string) => {
    PosController.getPosList(
      new RequestListPartner({
        page: 1,
        limit: 10,
        type: "pos",
        cityCode: this.detailData.partnerLocationCityCode,
        search: search,
        posType: "parent"
      })
    );
  }, 250);

  get isLoadingParentPos() {
    return PosController.isLoading;
  }

  get parentPos() {
    return PosController.posList.data.map((item: PosData) => ({
      id: item.id,
      name: item.name
    }));
  }

  setPartnerPosParentId(obj: any) {
    this.detailData.partnerPosParentId = obj.id;
  }
  
  setPartnerOwnershipId(obj: any) {
    this.detailData.partnerOwnershipId = obj.id;
  }

  formatCommission(value: string) {
    return formatInputFloat(value, 2);
  }

  errorCaptionCommision = "";
  validateCommision(value: string) {
    value = value.replace(/,/g, ".");
    if (Number(value) < 0) {
      this.error.commision = true;
      this.errorCaptionCommision = "Komisi tidak boleh nol/kosong";
    } else if (Number(value) > 100) {
      this.error.commision = true;
      this.errorCaptionCommision = "Komisi tidak boleh lebih dari 100%";
    } else {
      this.error.commision = false;
    }
  }
  filterPartnerPosReverseJourney = debounce((search: string) => {
    PosController.getPosList(
      new RequestListPartner({
        page: 1,
        limit: 10,
        type: "pos",
        cityCode:
          typeof this.detailData.partnerDistrict === "object"
            ? this.detailData.partnerDistrict.city_code
            : this.detailData.partnerLocationCityCode,
        search: search,
        posType: "parent",
        contractStatus: "active"
      })
    );
  }, 250);

  get posReverseJourney() {
    return PosController.posList.data?.map((data: any) => {
      return {
        name: `${data.code}-${data.name}`,
        id: data.id
      };
    });
  }

  updateFiles(files: string[]) {
    this.detailData.partnerPosAttachFiles = files;
  }

  get validateFiles() {
    const newFiles = this.detailData.partnerPosAttachFiles.filter((item: string) => item);
    return newFiles.length < 3
  }

  formatDebitBalance(value: string) {
    return formatInputMoney(value.replace(/[\D]+/g, ""));
  }

  isLoadingUpload = false;
  setLoadingUpload(status: boolean) {
    this.isLoadingUpload = status;
  }

  get showAddOrDeleteBankAccountButton() {
    return FlagsPermissionPartnerManagement.show_hide_bank_section.isEnabled();
  }

  get filesView() {
    return this.detailData.partnerPosAttachFiles.map(
      (item: string) => {
        const formatSplited = item.split(".");
        const isPdf = item.includes("path=pdf");
        return {
          url: item,
          type: isPdf ? "pdf" : formatSplited[formatSplited.length - 1]
        };
      }
    );
  }
}
